import * as React from 'react';

import ListMonths from '../../components/list/months';
import { ListContainerProps } from '../../components/list/container';
import MonthSelectionDropdown from '../../components/month-selection/dropdown';
import CalendarViewToggle from '../../components/calendar-view-toggle';

const ListMonthsContainerView: React.StatelessComponent<ListContainerProps> = props => {
    return (
        <div className="ace-cal-list-container">
            <p className="ace-cal-list-count">{`${props.eventCount} ${props.eventCount === 1 ? props.text.eventSingleString : props.text.eventsPluralString}`}</p>
            <ListMonths />
        </div>
    );
}

export default ListMonthsContainerView;